import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Form, Grid, Select } from 'semantic-ui-react';
import classNames from 'classnames';

import * as scheduleHelpers from 'Common/Helpers/ScheduleHelpers';

export class SchedulerField extends Component {
  static propTypes = {
    showDays: PropTypes.bool,
    minuteGranularity: PropTypes.number,
  };

  static defaultProps = {
    showDays: true,
    minuteGranularity: 15,
  };

  state = {
    schedule: 'YYYYYYY0000',
    amPm: scheduleHelpers.amPmEnum.AM,
  };

  componentDidUpdate() {
    const {
      input: { value, onChange },
      showDays,
    } = this.props;

    const { schedule, amPm } = this.state;

    if (value && value !== schedule) {
      let newSchedule = value;

      if (!showDays) {
        newSchedule = scheduleHelpers.setDays(
          value,
          Object.values(scheduleHelpers.dayEnum)
        );

        //note that by changing this here, we're potentially forcing forms to be
        //marked dirty on page load (if a dev has changed this field's props).
        //if we don't want this, this can be removed
        if (newSchedule !== value) {
          onChange(newSchedule);
        }
      }

      this.setState({ schedule: newSchedule });

      //update am/pm as well
      const newAmPm = scheduleHelpers.getAmPm(value);

      if (newAmPm !== amPm) {
        this.setState({ amPm: newAmPm });
      }
    }
  }

  handleDaysChange = (days) => {
    const schedule = scheduleHelpers.setDays(this.state.schedule, days);

    //update schedule
    this.setState({ schedule });
    this.props.input.onChange(schedule);
  };

  handleHoursChange = (hours) => {
    const { schedule: oldSchedule, amPm } = this.state;

    const schedule = scheduleHelpers.setHours(oldSchedule, hours, amPm);

    //update schedule
    this.setState({ schedule });
    this.props.input.onChange(schedule);
  };

  handleMinutesChange = (minutes) => {
    const schedule = scheduleHelpers.setMinutes(this.state.schedule, minutes);

    //update schedule
    this.setState({ schedule });
    this.props.input.onChange(schedule);
  };

  handleAmPmChange = (amPm) => {
    const schedule = scheduleHelpers.setAmPm(this.state.schedule, amPm);

    //update schedule and am/pm
    this.setState({ schedule, amPm });
    this.props.input.onChange(schedule);
  };

  render() {
    const {
      showDays,
      minuteGranularity,
      label,
      input: { onBlur },
      onChange,
      meta: { touched, error },
      required,
      ...inputProps
    } = this.props;

    const { schedule, amPm } = this.state;

    //calculate class names
    const displayLabel = label && label.length;
    const labelClassName = classNames({ error: touched && error });

    return (
      <Form.Field error={touched && error} required={required}>
        {displayLabel && (
          <label className={labelClassName} style={{ marginBottom: '1rem' }}>
            {label}
          </label>
        )}

        <Grid>
          {showDays && (
            <Grid.Row>
              <Grid.Column width={16}>
                <Select
                  {...inputProps}
                  placeholder="Days"
                  options={scheduleHelpers.dayOptions}
                  onChange={(e, { value }) => this.handleDaysChange(value)}
                  value={scheduleHelpers.getDays(schedule)}
                  multiple
                  fluid
                  onBlur={onBlur}
                />
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column width={5}>
              <Select
                {...inputProps}
                options={scheduleHelpers.hourOptions}
                placeholder="Hour"
                onChange={(e, { value }) => this.handleHoursChange(value)}
                value={scheduleHelpers.getHours(schedule)}
                fluid
                onBlur={onBlur}
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Select
                {...inputProps}
                placeholder="Minutes"
                options={scheduleHelpers.makeMinuteOptions(minuteGranularity)}
                onChange={(e, { value }) => this.handleMinutesChange(value)}
                value={scheduleHelpers.getMinutes(schedule)}
                fluid
                onBlur={onBlur}
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Select
                {...inputProps}
                options={scheduleHelpers.amPmOptions}
                placeholder="AM or PM"
                onChange={(e, { value }) => this.handleAmPmChange(value)}
                value={amPm}
                fluid
                onBlur={onBlur}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {touched && error && (
          <span className="input--message-error">{error}</span>
        )}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/ReduxFormFields/SchedulerField.js